/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiArtifactFromJSON, StreemApiArtifactToJSON, } from './';
export function StreemApiFulfillStreemshotResponseFromJSON(json) {
    return StreemApiFulfillStreemshotResponseFromJSONTyped(json, false);
}
export function StreemApiFulfillStreemshotResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'streemshotArtifact': !exists(json, 'streemshot_artifact') ? undefined : StreemApiArtifactFromJSON(json['streemshot_artifact']),
    };
}
export function StreemApiFulfillStreemshotResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'streemshot_artifact': StreemApiArtifactToJSON(value.streemshotArtifact),
    };
}
//# sourceMappingURL=StreemApiFulfillStreemshotResponse.js.map